export const messageConstant = {
  noRecommendedConversionMessage: 'Distance not calculating. Enter manual distance',
};
